import InstancesPage from '../pages/InstancesPage.vue';
import MessagesPage from '../pages/MessagesPage.vue';

// Rotas para funcionalidades do WhatsApp
const whatsappRoutes = [
  {
    path: '/whatsapp',
    redirect: '/whatsapp/instances'
  },
  {
    path: '/whatsapp/instances',
    name: 'whatsapp-instances',
    component: InstancesPage,
    meta: {
      requiresAuth: true,
      title: 'Instâncias do WhatsApp',
      icon: 'pi pi-whatsapp'
    }
  },
  {
    path: '/whatsapp/instance/:instanceId/messages',
    name: 'whatsapp-messages',
    component: MessagesPage,
    props: true,
    meta: {
      requiresAuth: true,
      title: 'Mensagens do WhatsApp',
      icon: 'pi pi-comments'
    }
  }
];

export default whatsappRoutes; 